import React, { useState } from 'react';

import {
	FormControl,
	FormLabel,
	FormGroup,
	FormControlLabel,
	Checkbox,
	Box,
	FormHelperText,
} from '@mui/material';

import {
	IQuestionnaireFormWidgetProps,
	IValueSelect,
} from 'src/features/questionnaire/domain/types';

const CheckBoxWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const submittedValues = question.submitted_data?.value_multi_select ?? [];

	const [selectedCheckboxes, setSelectedCheckboxes] = useState<Set<string>>(
		new Set(submittedValues.map((v: IValueSelect) => v.value.toString())),
	);

	const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const optionId = e.target.value;
		const newSelected = new Set(selectedCheckboxes);

		if (e.target.checked) {
			newSelected.add(optionId);
		} else {
			newSelected.delete(optionId);
		}

		setSelectedCheckboxes(newSelected);

		const updatedData = Array.from(newSelected).map((id) => ({
			value: id,
		}));

		onValueChange(question, updatedData, 'value_multi_select');
	};

	return (
		<FormControl
			component='fieldset'
			required={question.is_required}
			disabled={isDisabled}
			sx={{ width: '100%', textAlign: 'left' }}
			error={error}
		>
			<FormLabel component='legend'>{question.text}</FormLabel>
			<FormGroup>
				{question.options.map((option) => {
					const optionId = option.id.toString();
					const isChecked = selectedCheckboxes.has(optionId);

					return (
						<Box
							key={option.id}
							sx={{
								display: 'flex',
								alignItems: 'center',
								mt: 0.5,
								width: '100%',
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={isChecked}
										onChange={handleCheckboxChange}
										value={optionId}
										disabled={isDisabled}
									/>
								}
								label={option.value}
								sx={{ marginLeft: 0 }}
							/>
						</Box>
					);
				})}
			</FormGroup>
			{error && <FormHelperText>{helperText}</FormHelperText>}
		</FormControl>
	);
};

export default CheckBoxWidget;
